import Vue from 'vue'
import VuePassword from 'vue-password'

Vue.use(VuePassword)